/* Non-interactive layout placeholders. Only opacity moves; geometry stays put. */
.loading.loading-shape { display:block; min-height:0; width:100%; color:var(--muted); }
.loading-shape > p.sr-only { margin:0; }
.loading-shape-content { display:flex; flex-direction:column; gap:18px; min-width:0; }
.loading-block { display:block; flex-shrink:0; width:100%; height:12px; border-radius:3px; background:var(--line); animation:loading-breathe 1.8s ease-in-out infinite; }
.loading-block.short { width:32%; }
.loading-block.medium { width:62%; }
.loading-block.long { width:90%; }
.loading-block.title { width:55%; max-width:280px; height:25px; }
.loading-block.number { width:36%; height:32px; }
.loading-block.tag { width:48px; height:20px; }
.loading-block.avatar { width:24px; height:24px; border-radius:50%; }
.loading-block.day { width:15px; height:12px; }
.loading-block.event { height:15px; margin-top:20px; }
.loading-block.input { height:36px; }
.loading-block.action { width:90px; height:34px; }
.loading-lines { display:flex; flex-direction:column; flex:1; min-width:0; gap:10px; }
.loading-panel { min-width:0; padding:20px; border:1px solid var(--line); border-radius:6px; background:var(--paper); display:flex; flex-direction:column; gap:18px; }
.loading-list-row { display:flex; align-items:center; gap:16px; min-height:55px; padding:10px 0; border-bottom:1px solid var(--line); }
.loading-list-row:last-child { border-bottom:0; }
.loading-page-head { display:flex; align-items:center; justify-content:space-between; gap:24px; min-height:74px; margin-bottom:8px; }
.loading-page-head > div { display:flex; flex-direction:column; flex:1; gap:14px; }
.loading-toolbar { display:flex; align-items:center; gap:10px; margin-bottom:4px; }
.loading-toolbar > .input { max-width:260px; flex:1; min-width:0; }
.loading-kanban { display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); gap:0; border:1px solid var(--line); border-radius:6px; overflow:hidden; min-height:470px; }
.loading-lane { min-width:0; padding:10px; background:var(--soft); border-right:1px solid var(--line); }
.loading-lane:last-child { border-right:0; }
.loading-lane-head { display:flex; justify-content:space-between; align-items:center; height:34px; margin-bottom:12px; }
.loading-task { padding:12px; gap:16px; margin-bottom:10px; }
.loading-task > .long { height:4px; width:100%; }
.loading-person { display:flex; align-items:center; gap:8px; }
.loading-table { padding:0; gap:0; overflow:hidden; }
.loading-table-row { display:grid; grid-template-columns:2fr repeat(4,1fr); align-items:center; gap:20px; padding:18px 20px; min-height:56px; border-bottom:1px solid var(--line); }
.loading-table-row:first-child { background:var(--soft); min-height:44px; }
.loading-table-row:last-child { border-bottom:0; }
.loading-calendar { display:grid; grid-template-columns:repeat(7,minmax(0,1fr)); gap:1px; padding:0; overflow:hidden; background:var(--line); }
.loading-calendar > div { min-width:0; min-height:80px; padding:12px; background:var(--paper); }
.loading-metrics,.loading-card-grid { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:14px; }
.loading-detail { display:grid; grid-template-columns:minmax(0,1fr) 260px; gap:24px; }
.loading-document { gap:28px; min-height:570px; }
.loading-document > div { display:flex; flex-direction:column; gap:16px; padding-top:20px; border-top:1px solid var(--line); }
.loading-detail > .loading-panel > .loading-panel { padding:0; border:0; }
.loading-form { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:24px; }
.loading-form > div { display:flex; flex-direction:column; gap:12px; }
.loading-form > .action { grid-column:1/-1; justify-self:end; }
.loading-workflow { display:flex; flex-direction:column; gap:16px; }
.loading-dashboard { display:grid; grid-template-columns:minmax(0,1fr) minmax(260px,.7fr); gap:24px; }
.loading-dashboard > div { display:flex; flex-direction:column; gap:24px; min-width:0; }
.loading-dashboard .loading-metrics .loading-panel { padding:14px; }
.loading-dashboard .loading-calendar > div { min-height:58px; padding:8px; }
.loading-organization { display:grid; grid-template-columns:minmax(200px,.7fr) minmax(0,1.5fr); gap:24px; }
.section-card > .loading-shape,.modal > .loading-shape { padding:20px; }
.loading-variant-inline { padding:16px 0; }
.loading-variant-inline .loading-message { margin:0 0 12px; font-size:12px; }
.calendar-widget .loading-calendar > div { min-height:58px; padding:8px; }
@keyframes loading-breathe { 0%,100% { opacity:.55; } 50% { opacity:1; } }
@media(max-width:900px) {
  .loading-kanban { grid-template-columns:repeat(5,minmax(180px,1fr)); overflow-x:auto; }
  .loading-detail,.loading-dashboard,.loading-organization { grid-template-columns:minmax(0,1fr); }
}
@media(max-width:600px) {
  .loading-metrics,.loading-card-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
  .loading-form { grid-template-columns:minmax(0,1fr); }
  .loading-calendar > div { min-height:65px; padding:7px; }
  .loading-table-row { gap:10px; padding:16px 12px; grid-template-columns:2fr 1fr 1fr; }
  .loading-table-row > :nth-child(n+4) { display:none; }
  .loading-page-head { gap:12px; }
}
@media(prefers-reduced-motion:reduce) { .loading-block { animation:none; } }
